<template>
    <div class="w-full h-full justify-between">
        <div class='w-full flex overflow-y-scroll'>
            <div class="w-full grid grid-cols-12 border-gray-300 rounded-t">
                <div class="w-full bg-gray-50 border-y border-r col-span-1 border-l rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                    Reorder
                </div>
                <div class="w-full bg-gray-50 border-y border-r col-span-1 border-l rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                    Task Type*
                </div>
                <div class="w-full bg-gray-50 border-y border-r col-span-2 border-l rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                    Task Label
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                    Due Date
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                    Resolved Date
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                    User
                </div>
                <div class="w-full bg-gray-50 border-y border-r text-center  col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                    Status
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                    Notes
                </div>
                <div class="w-full bg-gray-50 border-y border-r  col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                    Correspondence
                </div>
            </div>
            <div class=" w-20 h-14  pl-1 py-0.5 flex flex-col justify-between items-end">
                <button title="Add open detail" class="bg-dark-secondary text-white hover:bg-dark-primary border  w-full h-6 rounded"
                    @click="addOpenTaskRow" 
                >
                + Open
                </button>
                <button title="Add done detail" class="bg-dark-secondary text-white hover:bg-dark-primary border w-full   h-6 rounded"
                    @click="addResolvedTaskRow" 
                >
                + Done
                </button>
            </div>
        </div>
        <div class="w-full h-full overflow-y-scroll max-h-[calc(100%-16rem)]">
                <TransitionGroup name="tasks">
                    <ClientTaskEditRow class="draggableRow transition-all duration-100" :ondragstart="task.resolved_date ? dragstartResolvedTaskHandler : dragstartOpenTaskHandler" :ondragend="dragEndHandler" :ondrop="task.resolved_date ? dropResolvedTaskHandler : dropOpenTaskHandler"  :ondragover="task.resolved_date ? dragoverResolvedTaskHandler : dragoverOpenTaskHandler"  :ondragleave="dragLeaveHandler"
                    draggable="true" :data-value="task.ordinal" :id="task.id" :drag-due-date="task.due_date" :drag-resolved-date="task.resolved_date"
                        v-for="task in newTasks"
                        :key="task.id"
                        :task="task"
                        :taskTypeOptions="clientTaskTypes"
                        :userOptions="userOptions"
                        :is-dragging="isDragging"
                        :dragging-due-date="draggingDueDate"
                        :dragging-resolved-date="draggingResolvedDate"
                        @update-task-row="updateTaskRow"
                        @remove-task-row="removeTaskRow"
                    />
                    <ClientTaskEditRow class="draggableRow transition-all duration-100" :ondragstart="dragstartOpenTaskHandler" :ondragend="dragEndHandler" :ondrop="dropOpenTaskHandler"  :ondragover="dragoverOpenTaskHandler"  :ondragleave="dragLeaveHandler"
                    draggable="true" :data-value="task.ordinal" :id="task.id" :drag-due-date="task.due_date"
                        v-for="task in orderedOpenTasks"
                        :key="task.id"
                        :task="task"
                        :taskTypeOptions="clientTaskTypes"
                        :userOptions="userOptions"
                        :is-dragging="isDragging"
                        :dragging-due-date="draggingDueDate"
                        @update-task-row="updateTaskRow"
                        @remove-task-row="removeTaskRow"
                    />
                    <ClientTaskEditRow class="draggableRow transition-all duration-100" :ondragstart="dragstartResolvedTaskHandler" :ondragend="dragEndHandler" :ondrop="dropResolvedTaskHandler"  :ondragover="dragoverResolvedTaskHandler"  :ondragleave="dragLeaveHandler" 
                    draggable="true" :data-value="task.ordinal" :id="task.id" :drag-resolved-date="task.resolved_date"
                        v-for="task in orderedResolvedTasks"
                        :key="task.id"
                        :task="task"
                        :taskTypeOptions="clientTaskTypes"
                        :userOptions="userOptions"
                        :is-dragging="isDragging"
                        :dragging-resolved-date="draggingResolvedDate"
                        @update-task-row="updateTaskRow"
                        @remove-task-row="removeTaskRow"
                    />
                </TransitionGroup>
        </div>
        <div class="flex w-full justify-center items-center absolute bottom-0 space-x-2 bg-white border-t border-gray-300 h-12">
            <button class="bg-accent-primary text-white hover:bg-accent-secondary px-2 py-1 rounded" @click="updateClientTasks">Save</button>
            <button class="bg-accent-primary text-white hover:bg-accent-secondary px-2 py-1 rounded" v-if="routeName=='client-tasks-spreadsheet'" @click="updateClientTasksAndClose">Save and Close</button>
            <button class="bg-dark-secondary text-white hover:bg-dark-primary px-2 py-1 rounded" @click="closeClientTaskEditForm">Cancel</button>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, watch, onUpdated, onMounted } from 'vue';
import { getTodaysDateAsString } from '@/composables/formatDate';
import ClientTaskEditRow from './ClientTaskEditRow.vue';
import { useRoute } from 'vue-router';



const props = defineProps(['client', 'clientTaskTypes', 'userOptions'])

const emit = defineEmits(['update-client-tasks', 'update-client-tasks-and-close', 'close-client-task-edit-form'])

const route = useRoute()

const clientTasks = ref(props.client ? props.client.tasks.map(task => ({...task, type: 1, task_order: task.task_type.ordinal})): [])

// console.log('client tasks first', clientTasks.value)

const routeName = computed(() => {
    return route.name
})

watch(clientTasks, () => {
}, {deep: true})

function sortByDueDate(a, b){
    if(a.due_date && b.due_date){
        if(a.due_date == b.due_date){
            return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
        } else {
            return new Date(a.due_date) - new Date(b.due_date)
        }
    } else if ((a.due_date && !b.due_date)){
        return 1
    } else if ((b.due_date && !a.due_date)){
        return -1
    } else {
        return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
    }
}


const orderedResolvedTasks = ref([])
const orderedOpenTasks = ref([])
const newTasks = ref([])

function setOrdinals(){
    for(let i = 0; i < orderedResolvedTasks.value.length; i++){
        orderedResolvedTasks.value[i].ordinal = i
    }
    for(let i = 0; i < orderedOpenTasks.value.length; i++){
        orderedOpenTasks.value[i].ordinal = i
    }
    for(let i = 0; i < newTasks.value.length; i++){
        newTasks.value[i].ordinal = i
    }
}

function sortByResolvedDate(a, b){
    if(a.resolved_date && b.resolved_date){
        if(a.resolved_date == b.resolved_date){
            return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
        } else {
            return new Date(b.resolved_date) - new Date(a.resolved_date)
        }
    } else if ((a.resolved_date && !b.resolved_date)){
        return -1
    } else if ((b.resolved_date && !a.resolved_date)){
        return 11
    } else {
        return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
    }
}

function orderTasks(){
    orderedResolvedTasks.value = clientTasks.value.filter((task) => task.resolved_date && task.type == 1).sort(sortByResolvedDate)
    orderedOpenTasks.value = clientTasks.value.filter((task) => !task.resolved_date).sort((a, b) => {
        return sortByDueDate(a, b)
    })
    newTasks.value = clientTasks.value.filter((task) => task.type != 1 && task.resolved_date).sort(sortByDueDate)
    setOrdinals()
}

orderTasks()

const isDragging = ref(false)
const draggingId = ref(null)
const draggingDueDate = ref(null)
const draggingResolvedDate = ref(null)

function dragoverOpenTaskHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    const targetDueDate = target.getAttribute("drag-due-date")
    if(targetDueDate == draggingDueDate.value){
        target.classList.add("border")
        target.classList.add("border-dark-primary")
        const currentDragElementOffset = ev.clientY
        const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
        const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
        if(currentDragElementOffset < targetDragElementOffset){
            ev.currentTarget.classList.add("translate-y-1")
        }
        if(currentDragElementOffset > targetDragElementOffset){
            ev.currentTarget.classList.add("-translate-y-1")
        }
    }
        ev.dataTransfer.dropEffect = "move"
  }

function dragoverResolvedTaskHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    const targetResolvedDate = target.getAttribute("drag-resolved-date")
    if(targetResolvedDate == draggingResolvedDate.value){
        target.classList.add("border")
        target.classList.add("border-dark-primary")
        const currentDragElementOffset = ev.clientY
        const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
        const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
        if(currentDragElementOffset < targetDragElementOffset){
            ev.currentTarget.classList.add("translate-y-1")
        }
        if(currentDragElementOffset > targetDragElementOffset){
            ev.currentTarget.classList.add("-translate-y-1")
        }
    }
        ev.dataTransfer.dropEffect = "move"
  }
function dragLeaveHandler(ev) {
    ev.preventDefault();
    let target = ev.currentTarget
    target.classList.remove("border")
    target.classList.remove("border-dark-primary")
    target.classList.remove("translate-y-1")
    target.classList.remove("-translate-y-1")
}

  function dropOpenTaskHandler(ev) {
    ev.preventDefault();
    isDragging.value = false
    const currentDragElementOffset = ev.clientY
    const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
    const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
    let data = ev.dataTransfer.getData("text/plain");
    data = JSON.parse(data)
    let draggingRow = clientTasks.value.find((row) => row.id == data.taskId)
    let dropRow = clientTasks.value.find((row) => row.id == ev.currentTarget.id)
    // console.log('drag row', draggingRow)
    // console.log('drop row', dropRow)
    if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
        let openTask = orderedOpenTasks.value.find((row) => row.id == data.taskId)
        if(openTask){
            let draggingRowIdx = orderedOpenTasks.value.findIndex((row) => row.id == data.taskId)
            orderedOpenTasks.value.splice(draggingRowIdx, 1)
            let dropRowIdx = orderedOpenTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedOpenTasks.value.splice(dropRowIdx, 0, openTask)
        }
    } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
        let openTask = orderedOpenTasks.value.find((row) => row.id == data.taskId)
        if(openTask){
            let draggingRowIdx = orderedOpenTasks.value.findIndex((row) => row.id == data.taskId)
            orderedOpenTasks.value.splice(draggingRowIdx , 1)
            let dropRowIdx = orderedOpenTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedOpenTasks.value.splice(dropRowIdx + 1, 0, openTask)
        }
    }
    // console.log('drag row after', draggingRow)
    // console.log('drop row after', dropRow)
    setOrdinals()
    draggingId.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-1")
    ev.currentTarget.classList.remove("-translate-y-1")
    orderTasks()
  }

function dropResolvedTaskHandler(ev) {
    ev.preventDefault();
    isDragging.value = false
    const currentDragElementOffset = ev.clientY
    const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
    const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
    let data = ev.dataTransfer.getData("text/plain");
    data = JSON.parse(data)
    let draggingRow = clientTasks.value.find((row) => row.id == data.taskId)
    let dropRow = clientTasks.value.find((row) => row.id == ev.currentTarget.id)
    // console.log('drag row', draggingRow)
    // console.log('drop row', dropRow)
    if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && (draggingRow.resolved_date == dropRow.resolved_date)){
        let resolvedTask = orderedResolvedTasks.value.find((row) => row.id == data.taskId)
        let resolvedNewTask = newTasks.value.find((row) => row.id == data.taskId)
        if(resolvedTask){
            let draggingRowIdx = orderedResolvedTasks.value.findIndex((row) => row.id == data.taskId)
            orderedResolvedTasks.value.splice(draggingRowIdx, 1)
            let dropRowIdx = orderedResolvedTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedResolvedTasks.value.splice(dropRowIdx, 0, resolvedTask)
        } else if(resolvedNewTask) {
            let draggingRowIdx = newTasks.value.findIndex((row) => row.id == data.taskId)
            newTasks.value.splice(draggingRowIdx, 1)
            let dropRowIdx = newTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
            newTasks.value.splice(dropRowIdx, 0, resolvedNewTask)
        }
    } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && (draggingRow.resolved_date == dropRow.resolved_date)){
        let resolvedTask = orderedResolvedTasks.value.find((row) => row.id == data.taskId)
        let resolvedNewTask = newTasks.value.find((row) => row.id == data.taskId)
        if(resolvedTask){
            let draggingRowIdx = orderedResolvedTasks.value.findIndex((row) => row.id == data.taskId)
            orderedResolvedTasks.value.splice(draggingRowIdx , 1)
            let dropRowIdx = orderedResolvedTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
            orderedResolvedTasks.value.splice(dropRowIdx + 1, 0, resolvedTask)
        } else if(resolvedNewTask){
            let draggingRowIdx = newTasks.value.findIndex((row) => row.id == data.taskId)
            newTasks.value.splice(draggingRowIdx , 1)
            let dropRowIdx = newTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
            newTasks.value.splice(dropRowIdx + 1, 0, resolvedNewTask)
        }
    }
    setOrdinals()
    draggingId.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-1")
    ev.currentTarget.classList.remove("-translate-y-1")
    orderTasks()
  }

function dragstartOpenTaskHandler(ev) {
    draggingId.value = ev.target.id
    // const companyId = ev.target.id
    isDragging.value = true
    // console.log('drag starting with id', ev.target.id)
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move"
    const taskOrdinal = ev.target.getAttribute('data-value')
    let draggingRow = clientTasks.value.find((row) => row.id == ev.target.id)
    draggingDueDate.value = draggingRow.due_date
    ev.dataTransfer.setData("text/plain", JSON.stringify({taskId: ev.target.id, taskOrdinal: taskOrdinal}));
}

function dragstartResolvedTaskHandler(ev) {
    draggingId.value = ev.target.id
    // const companyId = ev.target.id
    isDragging.value = true
    // console.log('drag starting with id', ev.target.id)
    ev.dataTransfer.effectAllowed = "move";
    ev.dataTransfer.dropEffect = "move"
    const taskOrdinal = ev.target.getAttribute('data-value')
    let draggingRow = clientTasks.value.find((row) => row.id == ev.target.id)
    // console.log('dragging row', draggingRow)
    draggingResolvedDate.value = draggingRow.resolved_date
    console.log('dragging resolved date', draggingResolvedDate.value)
    ev.dataTransfer.setData("text/plain", JSON.stringify({taskId: ev.target.id, taskOrdinal: taskOrdinal}));
}

function dragEndHandler(ev) {
    // console.log('drag ended')
    isDragging.value = false
    draggingId.value = null
    draggingDueDate.value = null
    draggingResolvedDate.value = null
    ev.currentTarget.classList.remove('border')
    ev.currentTarget.classList.remove('border-dark-primary')
    ev.currentTarget.classList.remove("translate-y-1")
    ev.currentTarget.classList.remove("-translate-y-1")
}



const campaignId = computed(() => {
    return props.company.campaign ? props.company.campaign.id : null
})


function updateClientTasks() {
    emit('update-client-tasks', clientTasks.value)
}


function updateClientTasksAndClose() {
    emit('update-client-tasks-and-close', clientTasks.value)
}

function closeClientTaskEditForm() {
    emit('close-client-task-edit-form')
}


function addOpenTaskRow() {
    const newTaskRow = {
        id: Math.floor(Math.random() * -100000),
        // action_name: null,
        task_type_id: null,
        resolved_date: null,
        due_date: null,
        status: null,
        user_id: null,
        task_notes: null,
        task_label: null,
        correspondence: null,
        type: 0,
        ordinal: 0.00000
    }
    clientTasks.value.splice(0, 0, newTaskRow)
    orderTasks()
    return newTaskRow
}

function addResolvedTaskRow() {
    const newTaskRow = {
        id: Math.floor(Math.random() * -100000),
        // action_name: null,
        task_type_id: null,
        resolved_date: getTodaysDateAsString(),
        due_date: null,
        status: null,
        user_id: null,
        task_notes: null,
        task_label: null,
        correspondence: null,
        type: 0,
        ordinal: 0.00000
    }
    clientTasks.value.splice(0, 0, newTaskRow)
    orderTasks()
    return newTaskRow
}

function removeTaskRow(taskId) {
    let rowIndex = clientTasks.value.findIndex((row) => row.id == taskId)
    clientTasks.value.splice(rowIndex, 1)
    orderTasks()
}

function updateTaskRow(taskRow) {
    let existingRow = clientTasks.value.find((row) => row.id == taskRow.id)
    existingRow.task_type = taskRow.task_type
    existingRow.task_type_id = taskRow.task_type_id
    existingRow.resolved_date = taskRow.resolved_date 
    existingRow.due_date = taskRow.due_date
    existingRow.user_id = taskRow.user_id
    existingRow.user = null
    existingRow.task_notes = taskRow.task_notes
    existingRow.task_label = taskRow.task_label
    existingRow.type = taskRow.type
    existingRow.correspondence = taskRow.correspondence
}

</script>

<style scoped>
.tasks-move,
.tasks-enter-active {
    transition: all 0.1s ease;
}
.tasks-leave-active {
  transition: all 0.08s ease;
}
.tasks-enter-from,
.tasks-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.tasks-leave-active {
    position: relative;
    /* position: relative; */
}
</style>